// Import Swiper styles
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/navigation";
import "../../../theme/SwiperOverrides.css";

import * as styles from "./SectionOurStoriesCarouselByTopic.module.scss";

import { A11y, Navigation } from "swiper/modules";
import { Swiper, type SwiperClass, SwiperSlide } from "swiper/react";

import React, { useState } from "react";
import { Pagination } from "../../../components/Pagination/Pagination";
import { StandardSignPostCard } from "../../../components/SignPostCards/StandardSignPostCard";
import { useStaticData } from "../../../hooks/useStaticData";
import sniffingDogImage from "../../../static/img/icon-sniffing-dog.png";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
export interface SectionOurStoriesCarouselByTopicProps {
	heading: string;
	topic: string;
	jumpLinksTitle?: string;
}

export const getSectionOurStoriesCarouselByTopicProps = ({
	field_front_end_title,
	field_jump_links_title,
}: Queries.SectionDataFragment) => ({
	heading: field_front_end_title,
	jumpLinksTitle: field_jump_links_title,
});

// TODO - TEST STATIC

export const SectionOurStoriesCarouselByTopic: React.FC<
	SectionOurStoriesCarouselByTopicProps
> = ({ heading, topic, jumpLinksTitle }) => {
	const { ourStoriesProps } = useStaticData(["ourStoriesProps"]);
	const [swiper, setSwiper] = useState<SwiperClass>(null);
	const [currentSlide, setCurrentSlide] = useState(0);
	const selectedStories = ourStoriesProps
		.filter((story) => story.topics?.includes(topic))
		.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

	const getBiggestCardTextCount = () => {
		const biggestCard = selectedStories.map((item) => {
			return (item.title?.length || 0) + (item.body?.length || 0);
		});
		return biggestCard.reduce((a, b) => Math.max(a, b), 0);
	};

	const prevSlide = () => {
		swiper?.slidePrev();
		setCurrentSlide((curr) => curr - 1);
	};
	const nextSlide = () => {
		swiper?.slideNext();
		setCurrentSlide((curr) => curr + 1);
	};
	const firstSlide = () => {
		swiper?.slideTo(0);
		setCurrentSlide(0);
	};
	const lastSlide = () => {
		swiper?.slideTo(selectedStories.length - 1);
		setCurrentSlide(selectedStories.length - 1);
	};

	const getSlideCount = (windowWidth: number) => {
		switch (true) {
			case windowWidth >= 900:
				return 2.5;
			case windowWidth >= 700:
				return 2.3;
			case windowWidth >= 500:
				return 1.5;
			case windowWidth >= 414:
				return 1.3;
			case windowWidth >= 320:
				return 1.1;
			default:
				return 1;
		}
	};

	return (
		<WrappedSection
			sectionName="SectionOurStoriesCarouselByTopic"
			sectionColour={Colours.WHITE}
		>
			<header className={styles.sectionheader}>
				{jumpLinksTitle ? (
					<h2 className={styles.title} data-jumplinkstitle={jumpLinksTitle}>
						{heading}
					</h2>
				) : (
					<h2 className={styles.title}>{heading}</h2>
				)}
				<img
					className={styles.dogimage}
					src={sniffingDogImage}
					alt={"sniffing dog icon"}
					width={387}
					height={125}
				/>
			</header>
			<div className={styles.swiperwrapper}>
				{selectedStories.length > 0 && (
					<Swiper
						aria-label={"Carousel of cards"}
						className={styles.swiper}
						modules={[Navigation, A11y]}
						centeredSlides={false}
						onSwiper={(swiper) => setSwiper(swiper)}
						noSwiping={true}
						initialSlide={0}
						preventClicks={false}
						spaceBetween={16}
						preventClicksPropagation={false}
						breakpoints={{
							320: {
								slidesPerView: getSlideCount(320),
							},

							414: {
								slidesPerView: getSlideCount(414),
							},
							500: {
								slidesPerView: getSlideCount(500),
							},

							700: {
								slidesPerView: getSlideCount(700),
							},

							900: {
								slidesPerView: getSlideCount(900),
							},
						}}
					>
						{selectedStories.map((signPostCard) => (
							<SwiperSlide key={signPostCard.title}>
								<StandardSignPostCard
									{...signPostCard}
									biggestSiblingTextCount={getBiggestCardTextCount()}
									buttonVariant="primary"
									forceSquare={true}
								/>
							</SwiperSlide>
						))}
					</Swiper>
				)}
				<div className={styles.pagination}>
					<Pagination
						onFirstClick={firstSlide}
						onPreviousClick={prevSlide}
						onNextClick={nextSlide}
						onLastClick={lastSlide}
						firstDisabled={currentSlide === 0}
						previousDisabled={currentSlide === 0}
						nextDisabled={currentSlide >= selectedStories.length - 1}
						lastDisabled={currentSlide >= selectedStories.length - 1}
						slim={true}
						position={currentSlide}
						total={selectedStories.length}
					/>
				</div>
			</div>
		</WrappedSection>
	);
};

export default SectionOurStoriesCarouselByTopic;
